import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

/// Emotion caches for both writing directions. The RTL cache flips logical properties for
/// Arabic; components use logical properties anyway, this covers what MUI emits itself.
export const ltrCache = createCache({ key: 'emiro', stylisPlugins: [prefixer] });

export const rtlCache = createCache({ key: 'emiro-rtl', stylisPlugins: [prefixer, rtlPlugin] });
